import get from 'lodash/get'

export const getUploadedImage = (state: Object) => get(state, 'settings.imgUrl')
